// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BackOrderModel, cancelBackOrder as cancelBackOrderApi } from "@guestsupply/App/Services/BackorderManagementService";
import { ApiHandler, createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<BackOrderModel & HasOnSuccess & HasOnError, any>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {...props.parameter};
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await cancelBackOrderApi(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.();
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const cancelBackOrder = createHandlerChainRunner(chain, "CancelBackOrder");
export default cancelBackOrder;
